import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder + primary-photo selection for a property's image gallery.
// Lives on a wrapper div with the URLs for the reorder and set-primary
// endpoints; each photo card carries data-attachment-id.
export default class extends Controller {
  static targets = ["grid"]
  static values = {
    reorderUrl: String,
    primaryUrlTemplate: String,
    primaryId: Number
  }

  connect() {
    this.csrf = document.querySelector('meta[name="csrf-token"]')?.content
    if (this.hasGridTarget) {
      this.sortable = Sortable.create(this.gridTarget, {
        animation: 150,
        handle: ".photo-drag-handle",
        ghostClass: "photo-ghost",
        onEnd: () => this.saveOrder()
      })
    }
    this.renderPrimary()
  }

  disconnect() {
    this.sortable?.destroy()
  }

  async setPrimary(event) {
    event.preventDefault()
    const id = event.currentTarget.dataset.attachmentId
    const url = this.primaryUrlTemplateValue.replace("ATTACHMENT_ID", id)
    if (await this.#patch(url)) {
      this.primaryIdValue = parseInt(id, 10)
      this.renderPrimary()
    }
  }

  async saveOrder() {
    const ids = Array.from(this.gridTarget.querySelectorAll("[data-attachment-id]"))
      .map((el) => parseInt(el.dataset.attachmentId, 10))
    await this.#patch(this.reorderUrlValue, { order: ids })
  }

  renderPrimary() {
    this.gridTarget?.querySelectorAll("[data-attachment-id]").forEach((wrapper) => {
      const isPrimary = parseInt(wrapper.dataset.attachmentId, 10) === this.primaryIdValue
      const card = wrapper.querySelector(".card")
      card?.classList.toggle("border-success", isPrimary)
      card?.classList.toggle("border-3", isPrimary)
      const label = wrapper.querySelector(".photo-primary-label")
      label?.classList.toggle("d-none", !isPrimary)
      const star = wrapper.querySelector(".photo-primary-btn i")
      if (star) {
        star.classList.toggle("fa-solid", isPrimary)
        star.classList.toggle("fa-regular", !isPrimary)
        star.classList.toggle("text-warning", isPrimary)
      }
    })
  }

  async #patch(url, body = null) {
    const opts = {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": this.csrf,
        Accept: "application/json"
      }
    }
    if (body) {
      opts.headers["Content-Type"] = "application/json"
      opts.body = JSON.stringify(body)
    }
    const response = await fetch(url, opts)
    return response.ok
  }
}
